import {Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CartCalculationService} from 'src/app/cart/service/cart-calculation.service';
import {VolumeDiscountProfile} from 'src/app/product-details/interface/volume-discount-profile';
import {VolumeDiscountProfileItem} from 'src/app/product-details/interface/volume-discount-profile-item';
import {GetAndSetCartDataInLocalstorageService} from 'src/app/cart/service/set-cart-data-in-localstorage.service';
import {PrepareInstockCalculationService} from 'src/app/product-details/service/prepare-instock-calculation.service';
import {PriceCalculationService} from 'src/app/product-details/service/price-calculation.service';
import {GlobalService} from 'src/app/services/global.service';
import {Product} from 'src/app/product-details/interface/product';
import {isPlatformBrowser} from '@angular/common';
import {PreOrderVolumeDiscountCalculationService} from '../../pre-order/service/pre-order-volume-discount-calculation.service';
import {FabricVolumeDiscuntCalculationService} from 'src/app/product-details/service/fabric-volume-discunt-calculation.service';

@Component({
	selector: 'fb-order-quantity',
	templateUrl: './order-quantity.component.html',
	styleUrls: ['./order-quantity.component.scss']
})
export class OrderQuantityComponent  implements OnInit, OnChanges{

	constructor(

		private _activatedRoute: ActivatedRoute,
		private _cartCalculation: CartCalculationService,
		private _getCartDataInLocal: GetAndSetCartDataInLocalstorageService,
		private _prepareItemInStockCalculation: PrepareInstockCalculationService,
		private _priceCalculation: PriceCalculationService,
		private _globalService: GlobalService,
		@Inject(PLATFORM_ID) private _platformId: Object,
		private _preOrderVolumeDiscountCalc: PreOrderVolumeDiscountCalculationService,
		private _fabricVolumeDiscountCalculation: FabricVolumeDiscuntCalculationService

	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	@Input() totalQuantityFromParent: number = {} as number;
	@Input() unitFromParent: string = {} as string;
	@Input() volumeDiscountProfile: VolumeDiscountProfile | undefined = {} as VolumeDiscountProfile;
	@Input() productData: Product = {} as Product;
	@Output() sendQtyToCartButton: EventEmitter<number> = new EventEmitter<number>();
	@Output() sendQtyToCartButtonPreOrder: EventEmitter<number> = new EventEmitter<number>();

	public quantity: number = 0;
	public totalQuantity: number = 1;
	public unit:string = '';
	public isProductFabric:boolean = false;
	public incDic: number = 1;
	public orderQuantityExceeded:boolean  = false;
	public minimumOrderQuantity: number = 0;
	public isPreOrderActive:boolean  = this._cartCalculation.isPreorder;
	public itemInStockLeft:number = 0;
	public isTheOrderInStock: boolean = true;
	public madeToOrderExceedMessage: boolean = false;
	public isBrowser: boolean = false;
	public isUserTryToDecreaseQuantityThanMOQ: boolean = false;
	public passedVDDiscount: VolumeDiscountProfileItem = {} as VolumeDiscountProfileItem;
	public isProductSwatch: boolean = false;


	public minusClicked(): void {
		if (this.volumeDiscountProfile && this.isPreOrderActive) {  // if pre-order
			// debugger
			if (this.quantity <= this.minimumOrderQuantity) return
			this.quantity = this.quantity - this.incDic;
		}
		else {
			if(this.quantity <= this.minimumOrderQuantity) {
				this.isUserTryToDecreaseQuantityThanMOQ = true;
			}
			if ((this.quantity <= this.incDic) || (this.quantity <= this.minimumOrderQuantity)) {
				return
			} else {
				this.quantity = this.quantity - this.incDic;
			}
		}
		if(this.quantity <  1) {
			this.quantity = 1;
		}

		// this.sendUpdate();
		this.orderQuantityExceeded = false;
		this._cartCalculation.quantity = this.quantity;

		// this._priceCalculation.productQuantity = this.quantity;
		// setTimeout(() => this._priceCalculation.calculatePrice(false, false), 0);

		this._priceCalculation.productQuantity = this.quantity;
			setTimeout(() => {
				this._priceCalculation.calculatePrice(false, false, 'order-quantity');
				this.sendUpdate();
			},0)

	}

	public plusClicked(): void {

		this.isUserTryToDecreaseQuantityThanMOQ = false;

		if (this.quantity >= this.totalQuantity) {
			this.orderQuantityExceeded = true;
			return
		} else {
			this.quantity = this.quantity + this.incDic;
			this.orderQuantityExceeded = false;
			this._cartCalculation.quantity = this.quantity;

			this._priceCalculation.productQuantity = this.quantity;
			setTimeout(() => {
				this._priceCalculation.calculatePrice(false, false, 'order-quantity');
				this.sendUpdate();
			},0)
		}
	}

	public quantityNumber(evt: any): void {

		this.isUserTryToDecreaseQuantityThanMOQ = false;
		this.orderQuantityExceeded = false;
		if (+(evt.target.value) < 0) {
			evt.target.value = '0';
		}

		if (+(evt.target.value) > this.totalQuantity) {
			evt.target.value = '0';
			this.orderQuantityExceeded = true;
		}

		if(+evt.target.value < 1)
			evt.target.value = '1';

		this.quantity = +(evt.target.value);


		if(this.isPreOrderActive || !this.isTheOrderInStock ) {
			if (+(evt.target.value) < this.minimumOrderQuantity) {
				evt.target.value = this.minimumOrderQuantity+'';
				this.quantity  = this.minimumOrderQuantity;
			}
		}

		// this.sendUpdate();


		// this._priceCalculation.productQuantity = this.quantity;
		// setTimeout(() => this._priceCalculation.calculatePrice(false, false), 0);

		this.sendUpdate();


		this._priceCalculation.productQuantity = this.quantity;
		setTimeout(() => {
			this._priceCalculation.calculatePrice(false, false, 'order-quantity');
			this.sendUpdate();
		},  0);


	}

	public sendUpdate(): void {

		this._cartCalculation.quantity = this.quantity;
		this.sendQtyToCartButtonPreOrder.emit(this.quantity);

		if(this.passedVDDiscount.id) {
			this._preOrderVolumeDiscountCalc.passedVolumeDiscount.next(
				this._fabricVolumeDiscountCalculation.passedVolumeDIscount
			);
		}

	}

	public ngOnInit(): void {
		// debugger

		this.totalQuantity = this.totalQuantityFromParent;
		this.sendQtyToCartButton.emit(this.totalQuantity)

		this._activatedRoute.params.subscribe(params => {
			if (params['category'] === 'fabric-product') {
				this.quantity = 1; // previously 0.5
				this.isProductFabric = true;
				this.incDic = .5;
			}
			else {
				this.quantity = 1;
				this.isProductFabric = false;
				this.incDic = 1;
			}

			this.isProductSwatch = this.productData.productGroup === 'swatch';

			if(this.productData.productGroup === 'swatch') this.incDic = 1;
			this._cartCalculation.quantity = this.quantity;
			this._priceCalculation.productQuantity = this.quantity;
			setTimeout(() => this._priceCalculation.calculatePrice(false, false, 'order-quantity'), 0);
		});


		if (!this.totalQuantity) this.quantity = 0
		else {
			// if (this.isProductFabric) this.quantity = 0.5
			// else this.quantity = 1
			this.quantity = 1;
		}

		this.unit = this.unitFromParent;

		this._prepareItemInStockCalculation.insockQuantity$.subscribe((itemLeft: number) => {

			this.itemInStockLeft = itemLeft;
			// debugger

			if (!this.isPreOrderActive) {

				this.totalQuantity = itemLeft;
				this.sendQtyToCartButton.emit(this.totalQuantity)
				if (!this.totalQuantity) {
					this.quantity = 0
				}
				else {

					// if (this.isProductFabric) this.quantity = 0.5;
					// else this.quantity = 1;
					this.quantity = 1;

					if(this._cartCalculation.orderType === 'MADE_TO_ORDER') {
						this.quantity = this.minimumOrderQuantity;
					}
				}
			}
			else { // if pre-order
				this.totalQuantity = 50000;
			}
		});


		this._getCartDataInLocal.openCartModal.subscribe((isCartOpen:boolean) :void =>{

			if(!isCartOpen) {
				// if(this.isProductFabric) this.quantity = 0.5;
				// else this.quantity = 1;
				this.quantity = 1;
				this._cartCalculation.quantity = this.quantity;
				this._priceCalculation.productQuantity = this.quantity;
			}
		});

		this._globalService.isTheOrderInstock.subscribe((isTheOrderInStock: boolean): void => {

			this.isTheOrderInStock = isTheOrderInStock;

			if(!isTheOrderInStock && !this.isPreOrderActive) {

				this.minimumOrderQuantity =this.productData.madeToOrderProfileEnabled && this.productData.madeToOrderProfile? this.productData.madeToOrderProfile?.minimumOrderQuantity:1;
				setTimeout(()=>{
					// let inpValue:any = document.getElementById('quantity_input');
					// inpValue.value = 5;
					console.log(this.minimumOrderQuantity)
					this.quantity = this.minimumOrderQuantity;
					this._cartCalculation.quantity = this.quantity;

					if(this.quantity>this.totalQuantity){
						this._globalService.disableAddToCart.next(true);
						this.madeToOrderExceedMessage = true;
					}
					else {
						this._globalService.disableAddToCart.next(false);
						this.madeToOrderExceedMessage = false;
					}


					this._priceCalculation.productQuantity = this.quantity;
					setTimeout(() => this._priceCalculation.calculatePrice(false, false, 'order-quantity'), 0);
				});
				// this.plusClicked();
			}

			else {
				if(!this.isPreOrderActive){
					this.minimumOrderQuantity = this.isProductFabric ? 0.5 : 1;
					this._globalService.disableAddToCart.next(false);
					this.madeToOrderExceedMessage = false;
				}

				if(isTheOrderInStock){
					this.quantity = 1;
				}
			}

			if(this.isPreOrderActive) {
				setTimeout(() => {
					this.preOrderQuantityCalculation();
				}, 0);
				this.madeToOrderExceedMessage = false;
			}
			else {
				this._priceCalculation.productQuantity = 1;
				setTimeout(() => this._priceCalculation.calculatePrice(false, false, 'order-quantity'), 0);
				return
			}

		});

		this.preOrderQuantityCalculation();

	}

	public ngOnChanges(changes: SimpleChanges): void {

		this.totalQuantity = this.totalQuantityFromParent;
		this.preOrderQuantityCalculation();
	}

	public preOrderQuantityCalculation(): void {

		let isPreOrderPopupOpen: string|null = '';

		if(this.isBrowser) {
			isPreOrderPopupOpen = localStorage.getItem('isPreOrderPopupOpen');
		}
		if (this.isPreOrderActive && this.volumeDiscountProfile && isPreOrderPopupOpen) {  // if pre-order
			this.totalQuantity = 50000;

			this.volumeDiscountProfile!.volumeDiscountProfileItemList.sort(
				(a: VolumeDiscountProfileItem, b: VolumeDiscountProfileItem) => a.minimumOrderQuantity - b.minimumOrderQuantity
			)

			let volumeDiscountProfileItemList = this.volumeDiscountProfile!.volumeDiscountProfileItemList;

			for (let i = 0; i < volumeDiscountProfileItemList.length; i++) {
				// debugger
				if (volumeDiscountProfileItemList[i].preOrder) {


					// setTimeout(() => {
						this.quantity = volumeDiscountProfileItemList[i].minimumOrderQuantity;
						this.minimumOrderQuantity = this.quantity;

						this._priceCalculation.productQuantity = this.quantity;
						this._priceCalculation.calculatePrice(false, false, 'order-quantity');
						this.passedVDDiscount = volumeDiscountProfileItemList[i];
					// }, 1);
					break

				}
			}




			this.sendUpdate();
		}
	}

	// public ngOnDestroy(): void {
	// 	this._priceCalculation.productQuantity = this.quantity;
	// }
}
